const DataCovers = {
  covers: [
    {
      number: 25,
      name: "August",
      descr: "",
      type: "cover",
      label: "new"
    },
    {
      number: 24,
      name: "Eva",
      descr: "",
      type: "cover",
      label: "new"
    },
    {
      number: 23,
      name: "Esther",
      descr: "",
      type: "cover",
      label: "new"
    },
    {
      number: 22,
      name: "Everly",
      descr: "",
      type: "cover",
      label: "new"
    },
    {
      number: 21,
      name: "Sharvil",
      descr: "",
      type: "cover",
      label: "new"
    },
    {
      number: 20,
      name: "Hilma",
      descr: "",
      type: "cover"
    },
    {
      number: 19,
      name: "Sofia",
      descr: "",
      type: "cover"
    },
    {
      number: 18,
      name: "Leva",
      descr: "",
      type: "cover"
    },
    {
      number: 17,
      name: "Taras",
      descr: "Fun page with a lot of farm animals that you can name, count and take with you into a trip. The big tractor wheel is removable.",
      type: "cover",
      img: "none"
    },
    {
      number: 16,
      name: "Martin",
      descr: "Fun page with a lot of farm animals that you can name, count and take with you into a trip. The big tractor wheel is removable.",
      type: "cover",
      img: "none"
    },
    {
      number: 15,
      name: "Mario",
      descr: "Fun page with a lot of farm animals that you can name, count and take with you into a trip. The big tractor wheel is removable.",
      type: "cover",
      img: "none"
    },
    {
      number: 14,
      name: "Nikita",
      descr: "Fun page with a lot of farm animals that you can name, count and take with you into a trip. The big tractor wheel is removable.",
      type: "cover",
      img: "none"
    },
    {
      number: 13,
      name: "Arvid",
      descr: "Fun page with a lot of farm animals that you can name, count and take with you into a trip. The big tractor wheel is removable.",
      type: "cover",
      img: "none"
    },
    {
      number: 12,
      name: "Max",
      descr: "Fun page with a lot of farm animals that you can name, count and take with you into a trip. The big tractor wheel is removable.",
      type: "cover"
    },
    {
      number: 11,
      name: "Alex",
      descr: "Fun page with a lot of farm animals that you can name, count and take with you into a trip. The big tractor wheel is removable.",
      type: "cover",
      img: "none"
    },
    {
      number: 10,
      name: "Panda",
      descr: "Fun page with a lot of farm animals that you can name, count and take with you into a trip. The big tractor wheel is removable.",
      type: "cover",
      img: "none"
    },
    {
      number: 9,
      name: "McBat",
      descr: "Fun page with a lot of farm animals that you can name, count and take with you into a trip. The big tractor wheel is removable.",
      type: "cover"
    },
    {
      number: 8,
      name: "Platon",
      descr: "Fun page with a lot of farm animals that you can name, count and take with you into a trip. The big tractor wheel is removable.",
      type: "cover"
    },
    {
      number: 7,
      name: "Alex",
      descr: "Bright page that will teach you the sea and undersea transport and different kinds of fish. The ship and a submarine are moving.",
      type: "cover"
    },
    {
      number: 6,
      name: "Fly",
      descr: "Bright page that will teach you the sea and undersea transport and different kinds of fish. The ship and a submarine are moving.",
      type: "cover"
    },
    {
      number: 5,
      name: "Ryboolba",
      descr: "Check if your car is ready to a long trip. Is your accumulator in a good condition? Plus connected  to plus and mines to mines? Don't forget to check the oil in the engine and add more if its needed. Ready to drive? Enjoy!",
      type: "cover"
    },
    {
      number: 4,
      name: "Mario",
      type: "cover"
    },
    {
      number: 3,
      name: "Vanja",
      descr: "Page for children over 3 years old. They can start learning numbers and to count. Different shapes of beads influence positive to fine motor skills.",
      type: "cover"
    },
    {
      number: 2,
      name: "Owlenko",
      descr: "You can start learning to tie shoelaces just like grownups do it! The laces are different in shape and color to develop fine motor skills.",
      type: "cover"
    },
    {
      number: 1,
      name: "Giradlo",
      descr: "It is always fun for kid to associate the favourite toy with some character and imagine that it's alive. And of course different tacktile experience as well.",
      type: "cover"
    }
  ],
  all: function() { return this.covers },
  get: function(id) {
    const isCover = p => p.number === id
    return this.covers.find(isCover)
  }
}

export default DataCovers



// WEBPACK FOOTER //
// ./src/components/API_Covers.js